import { FunctionComponent, useState, useEffect } from 'react';
import { first, isArray } from 'lodash';
import queryString from 'query-string';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES, DEFAULT_ERROR_MESSAGE } from '@/config/constants';
import { FlexInset } from '@/components';
import MagicLinkExpired from './MagicLinkExpired';
import { useLogin } from '@/hooks';
import { useSnackbar } from '@/design-system';

function normalizeQueryParam(param: string | string[] | null | undefined): string | null {
  if (!param) {
    return null;
  }
  if (isArray(param) && param.length > 0) {
    return atob(first(param)!);
  }
  return atob(param as string);
}

export const MagicLinkExpiredContainer: FunctionComponent = () => {
  const [params, setParams] = useState(() => {
    const { email, destination } = queryString.parse(window.location.search);

    return {
      email: normalizeQueryParam(email),
      destination: normalizeQueryParam(destination),
    };
  });
  const navigate = useNavigate();
  const showToast = useSnackbar();
  const { requestMagicLink } = useLogin();

  const resendLink = async () => {
    const magicLinkGenerated = await requestMagicLink(params.email!.toString());

    if (!magicLinkGenerated) {
      showToast({ message: DEFAULT_ERROR_MESSAGE });
    }
  };

  useEffect(() => {
    if (params.email) {
      // @ts-ignore
      setUserEmail(params.email);
    }
  }, []);

  if (!params.email || !params.destination) {
    navigate(APP_ROUTES.login);
  }

  return (
    <>
      <FlexInset>
        <MagicLinkExpired resendMagicLinkHandler={resendLink} />
      </FlexInset>
    </>
  );
};
